import { AbstractFileResource } from '../file/AbstractFile';
import { GET_PRESEIGNED_MEDIA_URL } from '../constants';
import axios, { AxiosResponse } from 'axios';

export interface PresignedResponse {
    url: string;
}

export class MediaAPI {
    public static getPresignedObject(fileResource: AbstractFileResource, id: string): Promise<PresignedResponse> {
        return fetch(GET_PRESEIGNED_MEDIA_URL, {
            headers: { 'Content-Type': 'application/json' },
            method: 'POST',
            body: JSON.stringify({ name: fileResource.name, size: fileResource.size, type: fileResource.getMimeType(), id })
        }).then((x) => x.json());
    }

    public static uploadToPresignedURL(fileResource: AbstractFileResource, url: string): Promise<string> {
        const headers = new Headers();
        headers.append('Content-Type', fileResource.getMimeType());
        headers.append('Content-Length', fileResource.size.toString());
        const fm = new FormData();
        fm.append('file', new Blob([fileResource.data]));
        return fetch(url, { method: 'PUT', headers: headers, body: fm })
            .then((s) => s.json())
            .then(() => url);
    }
}

export const getUploadApiUrl = (requestId: string, productId: string) => `product/${requestId}/${productId}/upload`;

export const uploadMedia = (requestId: string, productId: string, file: File): Promise<AxiosResponse<any>> => {
    const data = new FormData();
    data.append('file', file);
    return axios.post(getUploadApiUrl(requestId, productId), data);
};
